import { useLocation, useNavigate } from 'react-router-dom'
import useSidebarLinks from '@/hooks/hexaV2SideBarMenu/useSideBarLinks'
import { useMenuContext } from '@/contexts/menu'
import { HexaV2NavBar, HexaV2NavItemsContainer } from '@/components/hexa-v2'

import SplitControlledMenuItem from './components/SplitControlledMenuItem'
import UtilityMenuItems from './components/UtiltyMenuItems'

import * as S from './styles'

const HexaV2SideBarMenu = () => {
  const navigate = useNavigate()
  const { links } = useSidebarLinks()
  const { pathname } = useLocation()

  const {
    handleMenuMouseLeave,
    handleMenuMouseOver,
    isMenuOpen,
    isMobile,
    toggleIsMenuOpen,
  } = useMenuContext()

  const showMenu = !isMobile || isMenuOpen

  const handleCollapse = () => {
    if (isMobile) {
      toggleIsMenuOpen()
    }
  }
  const isItemActive = (pageLink: string) => {
    return pathname === pageLink
  }

  return (
    <S.MenuContainer className="hidden-print">
      {showMenu && (
        <S.NavBarContainer>
          <HexaV2NavBar
            onHxCollapse={handleCollapse}
            onHxChangeActive={handleCollapse}
            onMouseOver={handleMenuMouseOver}
            onMouseLeave={handleMenuMouseLeave}
            collapsed={!isMenuOpen}
          >
            <HexaV2NavItemsContainer>
              {links.map(item => (
                <SplitControlledMenuItem
                  key={item.id}
                  menuItem={item}
                  onClick={() => navigate(item.to || '')}
                  isItemActive={isItemActive(item.to || '')}
                />
              ))}
            </HexaV2NavItemsContainer>

            <UtilityMenuItems isMobile={isMobile} navigate={navigate} />
          </HexaV2NavBar>
        </S.NavBarContainer>
      )}
    </S.MenuContainer>
  )
}

export default HexaV2SideBarMenu
